/*
 * @Author: yangchong
 * @Description: 协同办公多语言配置包
 * @Date: 2019-11-30 15:15:06
 */
export default {
  '序号': 'No.',
  '其他平台': 'Other Platform',
  '自动获取': 'Auto-Get',
  '丽晶360终端物流': 'REGENTSOFT 360 Store Logistics',
  'POS自动填充收银员账号&密码': 'POS Autofill Cashier Account & Password',
  '协同平台设置': 'Collaborative Platform Setting',
  '平台名称': 'Platform Name',
  '网址': 'Website',
  '输入平台名称': 'Enter Platform Name',
  '输入网址': 'Enter Website',
  '需填写http': 'Need to Fill in http',
  '确定删除该记录吗？': 'Sure to delete this record?',
  '新增成功': 'Added',
  '保存成功': 'Saved',
  '请输入平台名称': 'Enter Platform Name',
  '请输入网址': 'Enter Website',
  '请输入正确的网址': 'Enter Right Website',
  '删除成功': 'Deleted',
  '新增': 'Add',
  '储位系统': 'Storage System',
  '店铺储位管理系统': 'Channel Storage Management System',
  '自定义排序': '',
  '是否取消自定义排序？': '',
  '已经是第一条，不可上': '',
  '已经是最后一条，不可下移': '',
  '修改成功': '',
  '取消': '',
  '保存': '',
  '平台类型': '',
  '外挂': '',
  'RP': 'RP'
}



// WEBPACK FOOTER //
// ./src/i18n/en/collaboraivePlatform.js